function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _JSXStyle from "styled-jsx/style";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import PropTypes from 'prop-types';
import React from 'react';
import Alert from 'reactstrap/lib/Alert';

var FeatureBanner =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FeatureBanner, _React$Component);

  var _super = _createSuper(FeatureBanner);

  function FeatureBanner() {
    _classCallCheck(this, FeatureBanner);

    return _super.apply(this, arguments);
  }

  _createClass(FeatureBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alertText = _this$props.alertText,
          color = _this$props.color,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          children = _this$props.children;
      var alertStyle = 'font-weight-bold text-uppercase';
      return (
        /*#__PURE__*/
        React.createElement(Alert, {
          color: color,
          className: "align-items-center d-flex p-0"
        }, alertText ?
        /*#__PURE__*/
        React.createElement("h2", {
          className: "jsx-3078563086" + " " + "".concat(alertStyle, " text-center m-0 px-3 d-none d-sm-block")
        }, alertText) : null,
        /*#__PURE__*/
        React.createElement("div", {
          className: "jsx-3078563086" + " " + "body d-flex flex-wrap p-3 w-100"
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: "jsx-3078563086" + " " + "info mr-auto"
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: "jsx-3078563086" + " " + "d-inline-block m-0"
        }, alertText ?
        /*#__PURE__*/
        React.createElement("h2", {
          className: "jsx-3078563086" + " " + "".concat(alertStyle, " d-inline d-sm-none mr-2")
        }, alertText) : null,
        /*#__PURE__*/
        React.createElement("h3", {
          className: "jsx-3078563086" + " " + "d-inline"
        }, title)),
        /*#__PURE__*/
        React.createElement("p", {
          className: "jsx-3078563086" + " " + "m-0"
        }, subtitle)),
        /*#__PURE__*/
        React.createElement("div", {
          className: "jsx-3078563086" + " " + "d-inline-block my-auto"
        }, children)),
        /*#__PURE__*/
        React.createElement(_JSXStyle, {
          id: "3078563086"
        }, ".body.jsx-3078563086{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}.body.jsx-3078563086 @media (min-width.jsx-3078563086:576px){border-left:1px solid rgba(0,0,0,0.1);}.info.jsx-3078563086{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;}"))
      );
    }
  }]);

  return FeatureBanner;
}(React.Component);

FeatureBanner.propTypes = {
  alertText: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  subtitle: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired
};
FeatureBanner.defaultProps = {
  alertText: 'new',
  color: 'info'
};
FeatureBanner.displayName = "FeatureBanner";
export { FeatureBanner as default };